export enum UserRole {
  NONE = 'NONE',
  PHARMA = 'PHARMA',
  PAYER = 'PAYER',
  PAYER_ADMIN = 'PAYER_ADMIN',
  PHARMA_ADMIN = 'PHARMA_ADMIN',
  QUANTUVIS_ADMIN = 'QUANTUVIS_ADMIN'
}
